/**
 * Visit polling routes — keep aligned with client-experience-backend pollRouter.ts
 */
export const pollingEndpoints = {
  visitPolls: (visitId) => `/visits/${visitId}/polls`,
  poll: (visitId, pollId) => `/visits/${visitId}/polls/${pollId}`,
  closePoll: (visitId, pollId) => `/visits/${visitId}/polls/${pollId}/close`,
  deletePoll: (pollId) => `/deletePoll/${pollId}`,
};

export default pollingEndpoints;
